import axios from 'axios';
import { getCourseAPIHost, getEnvironmentConstant } from '../common/utilities';
import { ROUTER_BASENAME } from '../common/constants';
import logger from '../common/logger';

const fetchFastTrackPlanById = async ({ entryId, env }) => {
  const host = getCourseAPIHost({ env, isPreview: false });
  const routerBasename = getEnvironmentConstant({ env, key: ROUTER_BASENAME });
  const apiUrl = `${host}${routerBasename}/api/fast-track-services/v1/${entryId}`;
  logger.info('Fetching FastTrack detail data from client', {
    env,
    entryId,
    routerBasename,
    apiUrl,
  });
  const response = await axios.get(apiUrl);
  return response.data;
};

export default fetchFastTrackPlanById;
